import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./lineSkeleton.scss";

export function SidebarSkeleton() {
  return (
    <div className="skeleton-wrapper d-flex flex-column align-items-center">
      <div className="w-100">
        {Array.from({ length: 14 }).map((_, idx) => (
          <div key={idx} className="d-flex align-items-center mb-3 width280">
            <Skeleton
              circle
              width={15}
              height={15}
              baseColor="#E0DDDDFF"
              highlightColor="#fdfdfdff"
            />
            <div className="ms-2 flex-grow-1">
              <Skeleton
                height={15}
                width={170}
                borderRadius={8}
                baseColor="#E0DDDDFF"
                highlightColor="#fdfdfdff"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SidebarLogoSkeleton() {
  return (
    <div className="skeleton-wrapper sidebarLogoSkeleton">
      <Skeleton
        width={220}
        height={30}
        borderRadius={8}
        baseColor="#dad6d6ff"
        highlightColor="#fdfdfdff"
      />
    </div>
  );
}
